import { useState, useEffect } from "react";
import Select from "react-select";
import DataFetcherTemplate from "../../hooks/fetchTemplate";

const facultadSlugMap = {
  empresas: "Ciencias Económicas y Empresariales",
  exactas: "Ciencias Exactas y Naturales",
  salud: "Ciencias de la Salud",
  sociales: "Ciencias Sociales, Educación y Humanidades",
  juridicas: "Ciencias Jurídicas y Políticas",
  ingenieria: "Ingenierías y Arquitectura",
  negocios: "UTPL Escuela de Negocios",
};

const facultadNameToSlug = Object.fromEntries(
  Object.entries(facultadSlugMap).map(([slug, name]) => [name, slug]),
);

// 🔧 Normalizador (para filtros)
const normalize = (str) =>
  str
    ?.toLowerCase()
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

// 🔥 Helper universal (soporta TODO)
const getFieldValues = (item, fields) => {
  const values = [];

  fields.forEach((field) => {
    const data = item[field];

    if (!data) return;

    if (Array.isArray(data)) {
      values.push(...data);
    } else {
      values.push(data);
    }
  });

  return values
    .map((v) => v?.toString().trim())
    .filter((v) => v && v.length > 0);
};

// 🔥 Helper especial para campos con comas
const getSplitValues = (item, fields) => {
  return getFieldValues(item, fields)
    .flatMap((v) => v.split(","))
    .map((v) => v.trim())
    .filter(Boolean);
};

function OfferPosgrados() {
  const optionsPrograma = [
    { value: "todos", label: "Todos los programas" },
    { value: "Maestría", label: "Maestría" },
    { value: "Especialización", label: "Especialización" },
    { value: "Doctorado", label: "Doctorado" },
  ];

  const optionsFacultad = [
    { value: "todos", label: "Toda la oferta" },
    { value: "Ciencias Económicas y Empresariales", label: "Ciencias Económicas y Empresariales" },
    { value: "Ciencias Exactas y Naturales", label: "Ciencias Exactas y Naturales" },
    { value: "Ciencias de la Salud", label: "Ciencias de la Salud" },
    { value: "Ciencias Sociales, Educación y Humanidades", label: "Ciencias Sociales, Educación y Humanidades" },
    { value: "Ciencias Jurídicas y Políticas", label: "Ciencias Jurídicas y Políticas" },
    { value: "Ingenierías y Arquitectura", label: "Ingenierías y Arquitectura" },
    { value: "UTPL Escuela de Negocios", label: "UTPL Escuela de Negocios" },
  ];

  const optionsModalidad = [
    { value: "todos", label: "Todas las modalidades" },
    { value: "En línea", label: "En línea" },
    { value: "Presencial", label: "Presencial" },
    { value: "Híbrida", label: "Híbrida" },
  ];

  const getInitialValue = (param, options) => {
    const params = new URLSearchParams(window.location.search);
    let value = params.get(param);

    if (param === "facultad" && facultadSlugMap[value]) {
      value = facultadSlugMap[value];
    }

    return options.find((o) => o.value === value) || options[0];
  };

  const [programaSeleccionado, setProgramaSeleccionado] = useState(
    getInitialValue("programa", optionsPrograma),
  );

  const [facultadSeleccionada, setFacultadSeleccionada] = useState(
    getInitialValue("facultad", optionsFacultad),
  );

  const [modalidadSeleccionada, setModalidadSeleccionada] = useState(
    getInitialValue("modalidad", optionsModalidad),
  );

  useEffect(() => {
    const params = new URLSearchParams();

    if (programaSeleccionado.value !== "todos")
      params.set("programa", programaSeleccionado.value);

    if (facultadSeleccionada.value !== "todos") {
      const slug = facultadNameToSlug[facultadSeleccionada.value];
      params.set("facultad", slug);
    }

    if (modalidadSeleccionada.value !== "todos")
      params.set("modalidad", modalidadSeleccionada.value);

    const newUrl =
      window.location.pathname +
      (params.toString() ? `?${params.toString()}` : "");

    window.history.replaceState({}, "", newUrl);
  }, [programaSeleccionado, facultadSeleccionada, modalidadSeleccionada]);

  const limpiarFiltros = () => {
    setProgramaSeleccionado(optionsPrograma[0]);
    setFacultadSeleccionada(optionsFacultad[0]);
    setModalidadSeleccionada(optionsModalidad[0]);
  };

  const DataDisplayOferta = ({ data }) => {
    const filteredData = data.filter((item) => {
      const matchPrograma =
        programaSeleccionado.value === "todos" ||
        normalize(item.field_programa).includes(
          normalize(programaSeleccionado.value),
        );

      const facultades = getFieldValues(item, ["field_area"]);
      const matchFacultad =
        facultadSeleccionada.value === "todos" ||
        facultades.some((f) =>
          normalize(f).includes(normalize(facultadSeleccionada.value)),
        );

      const modalidades = getFieldValues(item, [
        "field_modalidad",
        "field_modalidad_carrera",
      ]);

      const matchModalidad =
        modalidadSeleccionada.value === "todos" ||
        modalidades.some((m) =>
          normalize(m).includes(normalize(modalidadSeleccionada.value)),
        );

      return matchPrograma && matchFacultad && matchModalidad;
    });

    return (
      <>
        <div className="wrapper-filtros layout9">
          <div>
            <p><b>Programa</b></p>
            <Select
              options={optionsPrograma}
              value={programaSeleccionado}
              onChange={setProgramaSeleccionado}
            />
          </div>

          <div>
            <p><b>Facultad</b></p>
            <Select
              options={optionsFacultad}
              value={facultadSeleccionada}
              onChange={setFacultadSeleccionada}
            />
          </div>

          <div>
            <p><b>Modalidad</b></p>
            <Select
              options={optionsModalidad}
              value={modalidadSeleccionada}
              onChange={setModalidadSeleccionada}
            />
          </div>

          <div>
            <button className="btn-reset-filtros" onClick={limpiarFiltros}>
              Limpiar filtros
            </button>
          </div>
        </div>

        <div className="layout9">
          <p className="contador-resultados">
            {filteredData.length} programas encontrados
          </p>
        </div>

        <div className="wrapper-academicoffer margin">
          {filteredData.map((item, index) => {
            const modalidades = getFieldValues(item, [
              "field_modalidad",
              "field_modalidad_carrera",
            ]);

            const duraciones = getFieldValues(item, [
              "field_duracion",
              "field_posgrado_duracion",
            ]);

            const camposConocimiento = getSplitValues(item, [
              "field_posgrado_campo",
              "field_campo_amplio_del_conocimie",
            ]);

            const facultades = getFieldValues(item, ["field_area"]);
            const inicios = getFieldValues(item, ["field_inicio"]);

            return (
              <div key={index}>
                <div className="programa-imagen">
                  <img src={item.field_portada} alt={item.title} />
                </div>

                <div className="layout8">
                  <div className="flex">
                    <p className="tipoposgrado">{item.field_programa}</p>

                    {item.field_tag?.[0] && (
                      <p className="tag-2">{item.field_tag}</p>
                    )}
                  </div>

                  <h3>{item.title}</h3>

                  {modalidades.length > 0 && (
                    <p>
                      <b>Modalidad:</b> {modalidades.join(", ")}
                    </p>
                  )}

                  {duraciones.length > 0 && (
                    <p>
                      <b>Duración:</b> {duraciones.join(", ")}
                    </p>
                  )}

                  {camposConocimiento.length > 0 && (
                    <p>
                      <b>Campo del conocimiento:</b>{" "}
                      {camposConocimiento.join(", ")}
                    </p>
                  )}

                  {facultades.length > 0 && (
                    <p>
                      <b>Facultad:</b> {facultades.join(", ")}
                    </p>
                  )}

                  {inicios.length > 0 && (
                    <p>
                      <b>Inicio de clases:</b> {inicios.join(", ")}
                    </p>
                  )}

                  {item.field_enlace_contenido?.[0] && (
                    <div className="wrapper-link">
                      <a
                        className="link-offer"
                        href={item.field_enlace_contenido}
                        rel="noreferrer"
                      >
                        Ver programa
                        <span className="material-icons">
                          arrow_forward_ios
                        </span>
                      </a>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  };

  return (
    <DataFetcherTemplate url="https://utpl.edu.ec/maestrias/services/posgrados.json">
      {(data) => <DataDisplayOferta data={data} />}
    </DataFetcherTemplate>
  );
}

export default OfferPosgrados;